<template>
  <div class="lianbao" v-if="course.is_discount == 1">
    <div class="hd">
      <div class="left">
        <p class="title" v-if="currentDiscount">
          {{ currentDiscount.title }}
          <img
            @click="showRule = true"
            v-if="currentDiscount.rule"
            src="~@/assets/images/course/lian-tips@2x.png"
          />
          <span>{{ currentDiscount.introduction }}</span>
        </p>
        <p class="time">
          {{ currentDiscount.start_time | tsFormat('yyyy年MM月dd日 hh:mm') }} -
          {{ currentDiscount.end_time | tsFormat('yyyy年MM月dd日 hh:mm') }}
        </p>
      </div>
      <div class="right" v-if="discountList.length > 1">
        <el-button
          type="text"
          :disabled="currentDiscountIdx == 0"
          @click="discountLeft"
          class="left-arrow"
        ></el-button>
        <p class="line"></p>
        <el-button
          type="text"
          :disabled="discountList.length - 1 == currentDiscountIdx"
          @click="discountRight"
          class="right-arrow"
        ></el-button>
      </div>
    </div>
    <div class="lian-box">
      <div v-if="currentDiscount.display_tag == 1" class="tab">
        <p
          @click="tagChange(item)"
          v-for="(item, index) in currentDiscount.tags"
          :key="index"
          :class="currentDiscountId == item.id ? 'active' : ''"
        >
          {{ item.name }}
        </p>
      </div>
      <el-checkbox-group v-model="checkedCourse">
        <div class="item-box" :style="lianStyle">
          <template v-for="(item, index) in discountCourseListCopy">
            <div
              v-if="!currentDiscount.display_tag || item.tag_id == currentDiscountId"
              class="item"
              :class="{
                disabled: checkDisabled(item) || !!item.disabled,
                last: item.last,
                required: item.is_required == 1,
              }"
              :key="index"
              @click="clickItem(index)"
            >
              <p @click.stop="toDetail(item)" class="title">{{ item.title }}</p>
              <div class="valid">
                <span v-if="item.valid_end_time >= 0 && checkValid(item)">
                  <span>学习有效期：</span>
                  <!-- 测试说不存在已过期的情况，故这里屏蔽 -->
                  <!-- <span v-if="!valids[item.id]">已过期</span>
                  <template v-else>
                    <span
                      v-if="item.valid_end_time>0"
                    >{{item.valid_end_time|tsFormat("yyyy/MM/dd")}}截止</span>
                    <span v-else>长期有效</span>
                  </template>-->
                  <span v-if="item.valid_end_time > 0">
                    {{ item.valid_end_time | tsFormat('yyyy/MM/dd') }}截止
                  </span>
                  <span v-else>长期有效</span>
                </span>
                <template v-else>
                  学习有效期：
                  <template v-if="item.valid_type == 1">长期有效</template>
                  <template v-else-if="item.valid_type == 2">
                    {{ item.valid_time | tsFormat('yyyy/MM/dd') }}截止
                  </template>
                  <template v-else-if="item.valid_type == 3"> {{ item.valid_time }}天 </template>
                </template>
              </div>
              <div class="bottom">
                <!-- <template v-if="(item.has_buy != 1 || !valids[item.id]) && item.is_sold_out == 0"> -->
                <template v-if="!checkDisabled(item)">
                  <el-checkbox
                    :class="{ required: item.is_required == 1 }"
                    v-model="item.checked"
                    @change="clickItem(index)"
                    :disabled="!!item.disabled || item.is_required == 1"
                    :label="item"
                  ></el-checkbox>
                  <CurrencyNew :price="item.price"></CurrencyNew>
                </template>
                <template v-else>
                  <span></span>
                  <template v-if="item.has_buy == 1">
                    <span class="is-buy" v-if="valids[item.id]">已报名</span>
                  </template>
                  <span class="stock" v-else-if="item.is_sold_out == 1"> 已售罄 </span>
                </template>
              </div>
            </div>
          </template>
        </div>
      </el-checkbox-group>
    </div>
    <div class="select-box">
      <p class="s-title">
        已选课程（{{ checkedCourse.length }}）
        <span>已优惠{{ ((price - discountPrice) / 100).toFixed(2) }}元</span>
      </p>
      <div class="item-box">
        <template v-for="(item, index) in checkedCourse">
          <div class="item" :key="'title' + index">
            <p class="title">{{ item.title }}</p>
            <div class="bottom">
              <CurrencyNew :price="item.price"></CurrencyNew>
              <button
                v-if="index != 0 && item.is_required == 0"
                @click="index != 0 ? checkedCourse.splice(index, 1) : ''"
                type="button"
                class="delete"
              ></button>
            </div>
          </div>
          <div
            class="add"
            :key="index"
            v-if="(index + 1) % 5 != 0 && index + 1 != checkedCourse.length"
          ></div>
          <div
            class="equal"
            :key="index"
            v-if="checkedCourse.length > 1 && index + 1 == checkedCourse.length"
          ></div>
        </template>
        <div
          :style="{
            'margin-left': checkedCourse.length % 5 != 0 ? '9px' : '',
            float: 'left',
            'margin-bottom': '22px',
          }"
        >
          <CurrencyNew
            v-if="checkedCourse.length"
            :price="discountPrice"
            :priceUnderline="price"
            :priceTwo="true"
            :underlinePriceTwo="true"
            class="s-price"
          ></CurrencyNew>
          <button @click="discountBuy" class="to-submit" type="button">立即报名</button>
        </div>
      </div>
    </div>
    <el-dialog class="dialog-rule" title="- 活动规则 -" :visible.sync="showRule" width="580px">
      <div class="content" v-if="currentDiscount">
        {{ currentDiscount.rule }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Lianbao',
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    discountList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    discountCourseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      currentDiscountIdx: 0,
      currentDiscountId: '',
      lianStyle: {},
      checkedCourse: [JSON.parse(JSON.stringify(this.course))],
      showRule: false,
    };
  },
  watch: {
    course() {
      this.checkedCourse = [JSON.parse(JSON.stringify(this.course))];
    },
    discountCourseListCopy() {
      this.handleDiscountCourseListChange();
    },
  },
  computed: {
    discountCourseListCopy() {
      return this.discountCourseList;
    },
    price() {
      let price = 0;
      for (let value of this.checkedCourse) {
        price = price + Number(value.price);
      }
      return price;
    },
    currentDiscount() {
      if (this.discountList.length == 0) {
        return null;
      }
      let currentDiscountId = this.discountList[this.currentDiscountIdx].display_tag
        ? this.discountList[this.currentDiscountIdx].tags[0].id
        : '';
      this.tagChange({ id: currentDiscountId });
      return this.discountList[this.currentDiscountIdx];
    },
    discountPrice() {
      let price = 0;
      let countDiscountPrice = 0;
      let totalDiscountPrice = 0;
      let countArr = this.currentDiscount.rules.count;
      let priceArr = this.currentDiscount.rules.price;
      let countRebates = this.currentDiscount.rules.count_rebate;
      let n = this.checkedCourse.length;
      countArr.sort((a, b) => {
        return a.condition - b.condition;
      });
      priceArr.sort((a, b) => {
        return a.condition - b.condition;
      });
      if (countArr.length) {
        if (n >= countArr[0].condition && n < countArr[countArr.length - 1].condition) {
          for (let i = 0; i < countArr.length; i++) {
            if (n >= countArr[i].condition && n < countArr[i + 1].condition) {
              countDiscountPrice = countArr[i].price;
            }
          }
        } else if (n >= countArr[countArr.length - 1].condition) {
          countDiscountPrice = countArr[countArr.length - 1].price;
        }
      }
      price = this.price - countDiscountPrice;
      if (priceArr.length) {
        if (price >= priceArr[0].condition && price < priceArr[priceArr.length - 1].condition) {
          for (let i = 0; i < priceArr.length; i++) {
            if (price >= priceArr[i].condition && price < priceArr[i + 1].condition) {
              totalDiscountPrice = priceArr[i].price;
            }
          }
        } else if (price >= priceArr[priceArr.length - 1].condition) {
          totalDiscountPrice = priceArr[priceArr.length - 1].price;
        }
      }
      price = price - totalDiscountPrice;
      if (countRebates.length) {
        let countRebate = countRebates
          .filter((a) => n >= a.condition)
          .sort((a, b) => b.condition - a.condition)[0];
        if (countRebate) {
          price = parseInt(((price * countRebate.rebate) / 100).toFixed('0'));
        }
      }
      return price;
    },
    valids() {
      let valids = {};
      this.discountCourseList.forEach((course) => {
        let valid;
        if (course.has_buy != 1) {
          valid = false;
        } else {
          valid = this.$services.CourseService.checkBuyValid(course);
        }
        valids[course.id] = valid;
      });
      return valids;
    },
  },
  created() {
    this.handleDiscountCourseListChange();
  },
  methods: {
    handleDiscountCourseListChange() {
      this.discountCourseListCopy.forEach((item, index) => {
        if (item.is_required == 0) {
          return;
        }
        if (item.has_buy == 1 && this.valids[item.id]) {
          return;
        }
        if (item.is_sold_out == 1) {
          return;
        }
        this.clickItem(index);
      });
    },
    checkValid(item) {
      return this.$services.CourseService.checkBuyValid(item);
    },
    // 是否不可点
    checkDisabled(item) {
      // 没买过
      if (item.has_buy != 1) {
        return item.is_sold_out == 1;
      }
      // 买过
      if (item.disabled) {
        return true;
      }
      return this.checkValid(item);
    },
    toDetail(item) {
      this.$router.push({
        name: 'CourseShow',
        params: {
          id: item.id,
        },
      });
    },
    clickItem(index) {
      let item = this.discountCourseListCopy[index];
      if (item.disabled || item.is_sold_out) {
        return;
      }
      if (item.has_buy == 1 && this.$services.CourseService.checkBuyValid(item)) {
        return;
      }
      let id = item.id;
      for (let i = 0; i < this.checkedCourse.length; i++) {
        let checkedCourse = this.checkedCourse[i];
        if (checkedCourse.id == id) {
          if (checkedCourse.is_required == 1) {
            return;
          }
          this.checkedCourse.splice(i, 1);
          this.checkedChange(this.checkedCourse);
          return;
        }
      }
      this.checkedCourse.push(item);
      this.checkedChange(this.checkedCourse);
    },
    tagChange(item) {
      this.currentDiscountId = item.id;
      let idx = 0;
      for (let value of this.discountCourseListCopy) {
        if (!item.id || !value.tag_id || item.id == value.tag_id) {
          value.idx = idx;
          idx++;
        }
      }
      // 动态设置课程盒子样式
      if (idx > 10) {
        this.lianStyle = {
          width: Math.ceil(idx / 2) * 210 + (Math.ceil(idx / 2) - 1) * 22 + 'px',
          'padding-right': '40px',
        };
        for (let i = 0; i < this.discountCourseListCopy.length; i++) {
          if ((this.discountCourseListCopy[i].idx + 1) % Math.ceil(idx / 2) == 0) {
            this.discountCourseListCopy[i].last = true;
          } else {
            this.discountCourseListCopy[i].last = false;
          }
        }
      } else {
        for (let i = 0; i < this.discountCourseListCopy.length; i++) {
          if (this.discountCourseListCopy[i].idx == 4 || this.discountCourseListCopy[i].idx == 9) {
            this.discountCourseListCopy[i].last = true;
          } else {
            this.discountCourseListCopy[i].last = false;
          }
        }
        this.lianStyle = { width: '100%' };
      }
    },
    discountLeft() {
      this.currentDiscountIdx--;
      this.$emit('changeDiscount', this.currentDiscount);
      this.checkedCourse = [JSON.parse(JSON.stringify(this.course))];
    },
    discountRight() {
      this.currentDiscountIdx++;
      this.$emit('changeDiscount', this.currentDiscount);
      this.checkedCourse = [JSON.parse(JSON.stringify(this.course))];
    },
    checkedChange(val) {
      let ids = [];
      for (let mutex_course_ids of this.currentDiscount.mutex_courses) {
        for (let i = 0; i < val.length; i++) {
          let id = val[i].id;
          if (mutex_course_ids.indexOf(id) < 0) {
            continue;
          }
          mutex_course_ids.forEach((mutex_id) => {
            ids.push(mutex_id);

            let course = this.discountCourseList.find((c) => c.id == mutex_id);
            if (!course) {
              return;
            }
            if (mutex_id != id) {
              this.$set(course, 'disabled', true);
            } else {
              this.$set(course, 'disabled', false);
            }
          });
        }
      }
      this.discountCourseList
        .filter((c) => ids.indexOf(c.id) < 0)
        .forEach((c) => {
          this.$set(c, 'disabled', false);
        });
    },
    discountBuy() {
      for (let i = 0, len = this.discountCourseListCopy.length; i < len; i++) {
        let course = this.discountCourseListCopy[i];
        if (course.is_required == 0) {
          continue;
        }
        if (!this.checkedCourse.find((c) => c.id == course.id)) {
          return this.$error('课程《' + course.title + '》必须选择');
        }
      }
      let val = {};
      val.discountId = this.currentDiscount.id;
      val.totalPrice = this.price;
      let arr = [];
      for (let value of this.checkedCourse) {
        let obj = {};
        obj.shop_id = value.id;
        obj.coupon_id = 0;
        obj.shop_type = value.course_type;
        arr.push(obj);
      }
      val.checkedCourse = arr;
      val.currentDiscount = this.currentDiscount;
      this.$emit('discountBuy', val);
    },
  },
};
</script>
<style lang="scss" scoped>
.lianbao {
  margin-bottom: 20px;
  background-color: #fff;
  ::v-deep {
    .rmb-svg-new {
      height: 0.9em;
      font-size: 17px;
    }
  }
  .hd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 66px;
    padding: 0 8px 0 30px;
    background-color: #fcf4f0;
    box-sizing: border-box;
    .left {
      .title {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333;
        line-height: 20px;
        img {
          width: 16px;
          height: 16px;
          margin: 0 6px 0 10px;
          vertical-align: -2px;
          cursor: pointer;
        }
        span {
          font-size: 14px;
          color: $primary-color;
          vertical-align: 1px;
        }
      }
      .time {
        margin-top: 7px;
        font-size: 14px;
        color: #999;
        line-height: 14px;
      }
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .left-arrow {
        display: block;
        width: 49px;
        height: 49px;
        border: none;
        background: url('~@/assets/images/course/lian-left@2x.png') center no-repeat;
        background-size: 10px 18px;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url('~@/assets/images/course/lian-left-active@2x.png') center no-repeat;
          background-size: 10px 18px;
        }
        &.is-disabled {
          cursor: not-allowed;
          opacity: 0.5;
          &:hover {
            background: url('~@/assets/images/course/lian-left@2x.png') center no-repeat;
            background-size: 10px 18px;
          }
        }
      }
      .line {
        width: 1px;
        height: 24px;
        background-color: #e1d8d4;
      }
      .right-arrow {
        display: block;
        width: 49px;
        height: 49px;
        border: none;
        background: url('~@/assets/images/course/lian-right@2x.png') center no-repeat;
        background-size: 10px 18px;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url('~@/assets/images/course/lian-right-active@2x.png') center no-repeat;
          background-size: 10px 18px;
        }
        &.is-disabled {
          opacity: 0.5;
          cursor: not-allowed;
          &:hover {
            background: url('~@/assets/images/course/lian-right@2x.png') center no-repeat;
            background-size: 10px 18px;
          }
        }
      }
    }
  }
  .lian-box {
    width: 100%;
    border-radius: 5px;
    .tab {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: -26px;
      p {
        position: relative;
        height: 52px;
        padding: 0 30px;
        font-size: 16px;
        color: #999;
        line-height: 52px;
        cursor: pointer;
        &::before {
          position: absolute;
          top: 17px;
          right: 0;
          width: 1px;
          height: 18px;
          background-color: #cccccc;
          content: '';
        }
        &:last-child::before {
          display: none;
        }
      }
      .active {
        color: #333;
        &::after {
          position: absolute;
          left: 30px;
          bottom: 8px;
          width: calc(100% - 60px);
          height: 3px;
          background-color: $primary-color;
          border-radius: 1px;
          content: '';
        }
      }
    }
    & ::v-deep .el-checkbox-group {
      margin-top: 26px;
      padding: 0 30px;
      overflow-x: auto;
      .item-box {
        overflow: hidden;
        .item {
          float: left;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          width: 210px;
          height: 100px;
          margin: 0 22px 22px 0;
          padding: 11px 15px 12px;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          box-sizing: border-box;
          cursor: pointer;
          &:hover {
            border: 1px solid $primary-color;
          }
          &.required {
            background-image: url('~@/assets/images/course/lian-required@2x.png');
            background-repeat: no-repeat;
            background-position: right top;
            background-size: 40px 40px;
          }
          .title {
            font-size: 14px;
            color: #333;
            line-height: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .valid {
            color: #999;
            font-size: 12px;
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-checkbox {
              font-size: 18px;
              &.required {
                .el-checkbox__inner {
                  border: none !important;
                  background: url('~@/assets/images/course/lian-checked-disabled@2x.png') center
                    center/100% 100%;
                  &::after {
                    display: none;
                  }
                }
              }
              .el-checkbox__inner {
                width: 18px;
                height: 18px;
                border: 1px solid #bfbfbf;
                &::after {
                  width: 4px;
                  height: 8px;
                  left: 5px;
                }
                &:hover {
                  border: 1px solid $primary-color;
                }
              }
              .el-checkbox__label {
                display: none;
              }
              .is-checked {
                .el-checkbox__inner {
                  border: 1px solid $primary-color;
                }
              }
            }
            .price {
              font-family: PingFangSC-Medium;
              font-size: 18px;
              line-height: 15px;
              height: 15px;
            }
            .stock {
              font-size: 15px;
              color: #999;
            }
            .is-buy {
              font-size: 15px;
              color: #fc5623;
            }
          }
        }
        .disabled {
          background-color: #f5f5f5;
          border: 1px solid #e0e0e0;
          cursor: not-allowed;
          &:hover {
            border: 1px solid #e0e0e0;
          }
          .title {
            color: rgba(51, 51, 51, 0.5);
          }
          .bottom {
            .el-checkbox {
              .el-checkbox__inner {
                background-color: #f5f5f5;
                border: 1px solid #bfbfbf;
                &:hover {
                  border: 1px solid #bfbfbf;
                }
              }
              .el-checkbox__label {
                display: none;
              }
              .is-checked {
                .el-checkbox__inner {
                  border: 1px solid #bfbfbf;
                }
              }
            }
            .price {
              color: rgba(255, 45, 40, 0.5);
            }
            .stock {
              font-size: 16px;
              color: rgba(153, 153, 153, 0.5);
            }
            .is-buy {
              font-size: 16px;
              color: rgba(255, 45, 40, 0.5);
            }
          }
        }
        .last {
          margin-right: 0;
        }
      }
    }
  }
  .select-box {
    padding: 0 0 6px 30px;
    .s-title {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 20px;
      margin: 6px 0 16px;
      padding-left: 12px;
      font-size: 16px;
      color: #333;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 20px;
        background-color: #fcb723;
        border-radius: 1px;
        content: '';
      }
      span {
        display: inline-block;
        font-size: 14px;
        color: $primary-color;
      }
    }
    .item-box {
      overflow: hidden;
      .item {
        float: left;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        width: 210px;
        height: 100px;
        margin: 0 0 22px 0;
        padding: 11px 15px 12px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
          border: 1px solid $primary-color;
        }
        .title {
          font-size: 14px;
          color: #333;
          max-height: 40px;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .valid {
          color: #999;
          font-size: 14px;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          ::v-deep {
            .price {
              font-family: PingFangSC-Medium;
              font-size: 18px;
              height: 15px;
              line-height: 15px;
            }
          }
          .delete {
            display: block;
            width: 25px;
            height: 25px;
            background: url('~@/assets/images/course/lian-delete@2x.png') center no-repeat;
            background-size: 16px 17px;
            border: none;
            outline: none;
            cursor: pointer;
            &:hover {
              background: url('~@/assets/images/course/lian-delete-active@2x.png') center no-repeat;
              background-size: 16px 17px;
            }
          }
        }
      }
      .add,
      .equal {
        float: left;
        width: 22px;
        height: 100px;
        background: url('~@/assets/images/course/lian-add@2x.png') center no-repeat;
        background-size: 18px 18px;
      }
      .equal {
        background: url('~@/assets/images/course/lian-equal@2x.png') center no-repeat;
        background-size: 18px 18px;
      }
      & ::v-deep .s-price {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        .price-underline {
          font-size: 17px;
          line-height: 14px;
          height: 14px;
        }
        .price {
          margin-top: 10px;
          font-size: 26px;
          height: 20px;
          line-height: 20px;
          .decimal {
            font-size: 26px !important;
            height: 20px;
            line-height: 20px;
          }
        }
      }
      .to-submit {
        width: 136px;
        height: 36px;
        margin-top: 11px;
        padding: 0;
        background: linear-gradient(90deg, $primary-color-8, $primary-color);
        border: none;
        border-radius: 18px;
        font-weight: 400;
        font-size: 16px;
        color: #fff;
        line-height: 36px;
        cursor: pointer;
        outline: none;
        &:hover {
          background: linear-gradient(90deg, rgba(255, 129, 68, 1), rgba(253, 98, 50, 1));
        }
      }
    }
  }
}

.dialog-rule {
  & ::v-deep .el-dialog__header {
    padding: 25px 0 10px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #333;
    .el-dialog__headerbtn {
      font-size: 18px;
      color: #999;
    }
  }
  & ::v-deep .el-dialog__body {
    padding: 10px 0 30px;
    .content {
      min-height: 315px;
      max-height: 365px;
      padding: 0 30px;
      font-size: 14px;
      color: #999;
      line-height: 22px;
      overflow-y: auto;
    }
  }
}
</style>
